import englishStrings from "./strings.json";

export const strings = englishStrings;
